module.exports = {
  zIndex: {
    cookieBanner: 102,
    mobileMenu: 103,
    dialog: 104
  },
  breakpoints: {
    small: '639px',
    medium: {
      min: '640px',
      max: '884px'
    },
    large: {
      min: '885px',
      max: '1023px'
    },
    xLarge: '1024px'
  },
  typography: {
    defaultFont: "\"Gotham book\", sans-serif",
  },
  colors: {
    gray: {
      lightest: '#F4F4F9',
      lighter: '#EAEAEE',
      light: 'rgba(0,0,0,0.15)',
      main: 'rgba(0,0,0,0.8)',
      dark: '#252525'
    },
    green: '#a1ce08',
    teal: {
      washed: '#f5fcfc',
      light: '#4ED1DF',
      main: '#3BBECC'
    },
    orange: {
      light: '#FF6B43',
      main: '#F6572C'
    },
    purple: "#32325D",
    red: "#F6572C",
    white: "#FFF",
    whiteOpacity: 'rgba(255,255,255,0.8)',
    yellow: "#FABC00",
    black: '#000'
  },
};
